import { render, staticRenderFns } from "./projectSummary.vue?vue&type=template&id=6385bc8b&scoped=true"
import script from "./projectSummary.vue?vue&type=script&lang=js"
export * from "./projectSummary.vue?vue&type=script&lang=js"
import style0 from "./projectSummary.vue?vue&type=style&index=0&id=6385bc8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6385bc8b",
  null
  
)

export default component.exports